import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.trading_data.uploaded_documents.title',
        defaultMessage: 'Uploaded documents'
    },
    noUploadedDocuments: {
        id: '_.trading_data.uploaded_documents.no_uploaded_documents',
        defaultMessage: 'You have no uploaded documents.'
    },
    documentName: {
        id: '_.trading_data.uploaded_documents.document_name',
        defaultMessage: 'Name'
    },
    documentUploadDate: {
        id: '_.trading_data.uploaded_documents.document_uploaded_date',
        defaultMessage: 'Upload Date'
    },
    agedDebtorReport: {
        id: '_.trading_data.uploaded_documents.aged_debtor_report',
        defaultMessage: 'Aged Debtor Report'
    },
    vatReturn: {
        id: '_.trading_data.uploaded_documents.vat_return',
        defaultMessage: 'VAT Return'
    },
    bankStatement: {
        id: '_.trading_data.uploaded_documents.bank_statement',
        defaultMessage: 'Bank Statement'
    },
    businessPlan: {
        id: '_.trading_data.uploaded_documents.business_plan',
        defaultMessage: 'Business Plan'
    },
    filedAccounts: {
        id: '_.trading_data.uploaded_documents.filed_accounts',
        defaultMessage: 'Filed Accounts'
    },
    managementAccounts: {
        id: '_.trading_data.uploaded_documents.management_accounts',
        defaultMessage: 'Management Accounts'
    },
    personalID: {
        id: '_.trading_data.uploaded_documents.personal_id',
        defaultMessage: 'Personal ID'
    },
    shareholderID: {
        id: '_.trading_data.uploaded_documents.shareholder_id',
        defaultMessage: 'Shareholder ID'
    },
    shareholderRegistry: {
        id: '_.trading_data.uploaded_documents.shareholder_registry',
        defaultMessage: 'Share Registry'
    },
    businessAccounts: {
        id: '_.trading_data.uploaded_documents.business_accounts',
        defaultMessage: 'Business Accounts'
    },
    companyBylaws: {
        id: '_.trading_data.uploaded_documents.company_by_laws',
        defaultMessage: 'Company Bylaws'
    },
    tradeCertificate: {
        id: '_.trading_data.uploaded_documents.trade_certificate',
        defaultMessage: 'Trade Certificate'
    },
    articlesOfAssociation: {
        id: '_.trading_data.uploaded_documents.articles_of_association',
        defaultMessage: 'Articles of Association'
    },
    selfAssessmentTaxReturn: {
        id: '_.trading_data.uploaded_documents.self_assessment_tax_return',
        defaultMessage: 'Self Assessment Tax Return'
    },
    personalBankStatement: {
        id: '_.trading_data.uploaded_documents.personal_bank_statement',
        defaultMessage: 'Personal Bank Statement'
    },
    limitedPartnerID: {
        id: '_.trading_data.uploaded_documents.limited_partner_id',
        defaultMessage: 'Limited Partner ID'
    },
    PNLBalance: {
        id: '_.trading_data.uploaded_documents.pnl_balance',
        defaultMessage: 'PnL Balance'
    },
    profitAndLoss: {
        id: '_.trading_data.uploaded_documents.profit_and_loss',
        defaultMessage: 'Profit and Loss'
    },
    customerBrokerConsent: {
        id: '_.trading_data.uploaded_documents.customer_broker_consent',
        defaultMessage: 'Customer Broker Consent'
    },
    cashRegister: {
        id: '_.trading_data.uploaded_documents.cash_register',
        defaultMessage: 'Cash Register'
    },
    certificados: {
        id: '_.trading_data.uploaded_documents.certificados',
        defaultMessage: 'Certificados'
    },
    balanceSheet: {
        id: '_.trading_data.uploaded_documents.balance_sheet',
        defaultMessage: 'Balance Sheet'
    },
    managementAndBalanceAccounts: {
        id: '_.trading_data.uploaded_documents.management_and_balance_accounts',
        defaultMessage: 'Management and Balance Accounts'
    },
    yearEndManagementAndBalanceAccounts: {
        id: '_.trading_data.uploaded_documents.year_end_management_and_balance_accounts',
        defaultMessage: 'Year End Management and Balance Accounts'
    },
    yearEndManagementAccounts: {
        id: '_.trading_data.uploaded_documents.year_end_management_accounts',
        defaultMessage: 'Year End Management Accounts'
    },
    accountBalances: {
        id: '_.trading_data.uploaded_documents.account_balances',
        defaultMessage: 'Account Balances'
    },
    cashflowForecast: {
        id: '_.trading_data.uploaded_documents.cashflow_forecast',
        defaultMessage: 'Cashflow forecast'
    },
    outstandingDebtInformation: {
        id: '_.trading_data.uploaded_documents.outstanding_debt_information',
        defaultMessage: 'Debt position'
    },
    listOfShareholders: {
        id: '_.trading_data.uploaded_documents.list_of_shareholders',
        defaultMessage: 'List of shareholders'
    },
    other: {
        id: '_.trading_data.uploaded_documents.other',
        defaultMessage: 'Other'
    }
});
